import type { StoredConsent, ConsentPreferences } from '../CookieConsent.types';
import {
  COOKIE_CONSENT_KEY,
  COOKIE_CONSENT_VERSION,
  COOKIE_MAX_AGE_DAYS,
} from '../config/cookie-consent.config';

export function getStoredConsent(): StoredConsent | null {
  try {
    const raw = document.cookie.split('; ').find(row => row.startsWith(`${COOKIE_CONSENT_KEY}=`));

    if (!raw) return null;

    const value = decodeURIComponent(raw.split('=')[1]);
    const parsed: StoredConsent = JSON.parse(value);

    if (parsed.version !== COOKIE_CONSENT_VERSION) return null;

    return parsed;
  } catch {
    return null;
  }
}

export function setStoredConsent(preferences: ConsentPreferences): void {
  const stored: StoredConsent = {
    ...preferences,
    timestamp: new Date().toISOString(),
    version: COOKIE_CONSENT_VERSION,
  };

  const maxAge = COOKIE_MAX_AGE_DAYS * 24 * 60 * 60;
  const isSecure = window.location.protocol === 'https:';

  document.cookie = [
    `${COOKIE_CONSENT_KEY}=${encodeURIComponent(JSON.stringify(stored))}`,
    `max-age=${maxAge}`,
    `path=/`,
    `SameSite=Lax`,
    isSecure ? 'Secure' : '',
  ]
    .filter(Boolean)
    .join('; ');
}
